import { render, staticRenderFns } from "./CardOrderIntranet.vue?vue&type=template&id=63274854&scoped=true"
import script from "./CardOrderIntranet.vue?vue&type=script&lang=js"
export * from "./CardOrderIntranet.vue?vue&type=script&lang=js"
import style0 from "./CardOrderIntranet.vue?vue&type=style&index=0&id=63274854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63274854",
  null
  
)

export default component.exports